"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { useNativeHomeExperience } from "@/components/marketing/native-simple-home";
import { hidesNativeMarketingChrome } from "@/lib/native-signed-out-chrome";

type SignedOutAppChromeProps = {
  navigation: ReactNode;
  children: ReactNode;
};

const NATIVE_SHELL_CLASS =
  "ap-pad-safe-top flex min-h-dvh flex-col bg-(--mk-ink) bg-[radial-gradient(ellipse_120%_65%_at_50%_-8%,rgba(201,168,76,0.28),transparent_58%)]";

export function SignedOutAppChrome({
  navigation,
  children,
}: SignedOutAppChromeProps) {
  const pathname = usePathname();
  const isNative = useNativeHomeExperience();
  const concealChrome = hidesNativeMarketingChrome(pathname);

  if (isNative && concealChrome) {
    return (
      <div className={NATIVE_SHELL_CLASS} id="main-content">
        {children}
      </div>
    );
  }

  return (
    <>
      {concealChrome ? (
        <div className="native-app:hidden">{navigation}</div>
      ) : (
        navigation
      )}
      <div
        className={
          concealChrome
            ? "ap-offset-nav native-app:flex native-app:min-h-dvh native-app:flex-col native-app:bg-(--mk-ink) native-app:bg-[radial-gradient(ellipse_120%_65%_at_50%_-8%,rgba(201,168,76,0.28),transparent_58%)] native-app:!pt-[max(env(safe-area-inset-top,0px),var(--safe-area-inset-top,0px))]"
            : "ap-offset-nav"
        }
        id="main-content"
      >
        {children}
      </div>
    </>
  );
}
